import { theme } from '../../../themes/main';
import { SxStyles } from '../../../types';

const stickyHeaderXxs = '445px';

export const getStyles = (isStickyHeader?: boolean): SxStyles => ({
  buttonGroupField: {
    '.MuiButtonGroup-grouped[aria-checked="true"]': {
      backgroundColor: theme.palette.green.main,
      borderColor: theme.palette.green.main,
    },
  },
  button: {
    '& .MuiButton-startIcon': {
      [`@media (max-width: ${stickyHeaderXxs})`]: { transform: isStickyHeader ? 'translate(6px, 0)' : 'none' },
    },
  },
  buttonText: {
    [`@media (max-width: ${stickyHeaderXxs})`]: { display: isStickyHeader ? 'none' : 'block' },
  },
});
